import Vue from 'vue'
import Vuex from 'vuex'
import httpRequest from './http'
import api from './http/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    userInfo: {}
  },
  mutations: {
    updateUserInfo (state, userInfo) {
      window.zhuge.identify(userInfo.user_id, userInfo)
      state.userInfo = userInfo
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      httpRequest(api.userInfoApi).then((res) => {
        if (res.success) {
          commit('updateUserInfo', res.info)
        } else {
          console.log(res)
        }
      })
    },
    // 登录用户购买课程
    getPurchaseCourse ({ commit }, params) {
      return httpRequest(api.purchaseCourse, params)
    },
    // 匿名登录
    getGenerateSign ({ commit }, params) {
      return httpRequest(api.generateSignApi, params)
    },
    getLangList () {
      return httpRequest(api.langListApi)
    },
    // 课程列表接口
    getCourseLangs () {
      return httpRequest(api.courseLangsApi)
    },
    // 新闻首页
    getNewsIndex ({ commit }, params) {
      return httpRequest(api.newsIndexApi, params)
    },
    // 新闻详情
    getNewDetail ({ commit }, params) {
      return httpRequest(api.newDetailApi, params)
    },
    // 获取新闻列表
    getNewList ({ commit }, params) {
      return httpRequest(api.newListApi, params)
    }
  }
})
